<template>
  <div
    class="entry__top"
    :style="{
      filter: active ? '' : 'grayscale(1)'
    }"
    @click="scrollToTop"
  >
    <slot></slot>

    <!-- <transition name="reveal__notch">
      <div v-if="active" class="notch"></div>
    </transition> -->
  </div>
</template>


<script>
import ResponsiveImage from '@/components/responsive-image.vue'



export default {
  name: 'item-top-slot',
  props: {
    active: {
      // type: Boolean,
      required: true,
    },
    // content: {
    //   type: Object,
    //   required: true,
    // },
  },
  components: {
    ResponsiveImage, 
  },
  data () {
    return {
      assets: [],
      diff: 0,
      ticks: 0,
      scrollDuration: 20,
      totalByCategories: [],
    }
  },
  methods: {
    scrollBy () {
      window.scrollBy(0, this.diff)
      this.ticks ++
      if (this.ticks === this.scrollDuration) {
        this.ticks = 0
        return
      }
      window.requestAnimationFrame(this.scrollBy)
    },
    scrollToTop () {
      setTimeout(() => {
        this.diff = (this.$el.getBoundingClientRect().top - 80) / this.scrollDuration
        this.scrollBy()
      }, 300)
    },
    // filteredContent (cat) {
    //   const total = this.content[cat]
    //     .split(',')
    //     .map(x => x.trim())
    //     .map(x => x.toLowerCase())
    //     .filter(a => a.length)
    //     .filter(a => a !== 'n/a')
    //     .filter(a => a !== 'na')
    //     .length
    //   return total
    // },
    // storeAssetsTotals () {
    //   this.totalByCategories = Object.keys(this.$root.content.options.colors)
    //     .map(cat => {
    //       return {
    //         cat: cat,
    //         total: this.filteredContent(cat),
    //       }
    //     })
    // }
  },

  computed: {
    // style__partyTag () {
    //   return { backgroundColor: colors(this.content.party) }
    // },
  },

  mounted () {
    // this.storeAssetsTotals()
  },
  updated () {
    // this.storeAssetsTotals()
  }
}
</script>


<style scoped lang="sass">
@import index

// .wrapper
  // &__items
  //   position: relative
  //   width: 100%
  //   text-align: center
  // &__icons
  //   margin: 1px
  //   display: inline-block
  //   vertical-align: top
  //   height: 36px

.entry
  &__top
    transition: filter 300ms
    // min-height: 190px
    padding: 2px
    padding-bottom: 0
    overflow: hidden
    cursor: pointer
    // p.name
    //   margin: 0 auto
    //   margin-bottom: 10px
    //   margin-top: auto
    //   text-align: center
    //   font-size: 14px
    //   line-height: 16px
    // &--image
    //   transition: transform 200ms
    //   transform-origin: bottom
    //   width: 100%
    //   height: 0
    //   padding-bottom: 100%
    //   border-radius: 100px
    //   background: $color-grey-2
    //   margin-bottom: 12px
    //   overflow: hidden
    //   z-index: 100

.notch
  transition: all 400ms
  position: absolute
  border: solid 10px rgba(black, 0)
  border-bottom: solid 10px rgba($color-bluegrey-1, 1)
  width: 20px
  left: 50%
  bottom: 0
  margin: 0 auto
  transform: scale(1, 1) translate(-50%)

.reveal__notch
  &-enter-active
    transform-origin: bottom
    transform: scale(1, 1) translateX(-50%)
  &-leave-active
    transition: transform 200ms
    transform-origin: bottom
    transform: scale(1, 1) translateX(-50%)
  &-enter
    transform: scale(1, 0) translateX(-50%)
  &-leave-to
    transform: scale(1, 0) translateX(-50%)

// .info
//   background: $color-grey-4
//   display: flex
//   flex: 0 0 auto
//   align-items: flex-end
//   width: 55px
//   height: 50px
//   margin: 0 auto
//   margin-top: -43px
//   margin-bottom: 12px
//   border-radius: 4px
//   padding: 2px
//   z-index: 0
//   &__party
//     flex: 1 1 auto
//     padding-left: 4px
//     font-size: 12px
//     color: white
//   &__federal, &__state
//     flex: 0 0 auto
//     padding: 0 4px
//     border-radius: 2px
//     font-size: 12px
//     font-weight: 400
//   &__federal
//     background: rgba(black,0.6)
//     color: rgba(white, 0.7)
//   &__state
//     background: rgba(white,0.6)
//     color: rgba(black, 0.7)

// .counter
//   text-align: center
//   padding: 0 8px
//   margin-bottom: 10px
//   line-height: 6px
//   div
//     // display: inline-block
//   span
//     &.dot
//       display: inline-block
//       width: 8px
//       height: 8px
//       margin: 1px
//       border-radius: 10px
//       &__empty
//         border: solid 1px $color-grey-3
//         opacity: 0.5


</style>



// WEBPACK FOOTER //
// src/components/expanding-grid/item-top-slot.vue